export const DEFAULT_CONNECTION_NAME = 'MESSENGER_DEFAULT_CONNECTION';
